import { PptSlide } from '../types/ppt-slide';

interface PptGenerationResult {
  success: boolean;
  data?: PptSlide[];
  error?: Error;
}

function preserveSlideLayouts(slides: PptSlide[]): PptSlide[] {
  return slides;
}

export async function generatePptStructure(
  payload: {
    chatParams: any;
    promptname: string;
    abortController: AbortController;
  },
  mutateAsync: (payload: {
    chatParams: any;
    promptname: string;
    abortController: AbortController;
  }) => Promise<any>,
): Promise<PptGenerationResult> {
  try {
    const response = await mutateAsync(payload);

    if (response instanceof ReadableStream) {
      const reader = response.getReader();
      let result = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const chunk = new TextDecoder().decode(value);
        result += chunk;
      }

      try {
        const cleanResult = result
          .replace(/^```json\n?/, '')
          .replace(/\n?```$/, '')
          .trim();

        const parsedResult = JSON.parse(cleanResult) as PptSlide[];

        const slides = preserveSlideLayouts(parsedResult);

        return {
          success: true,
          data: slides,
        };
      } catch (parseError) {
        console.error('Failed to parse PPT structure:', parseError);
        return {
          success: false,
          error: new Error('Invalid PPT structure format'),
        };
      }
    }

    return {
      success: false,
      error: new Error('Unexpected response format'),
    };
  } catch (error) {
    if (error.name === 'AbortError') {
      return {
        success: false,
        error: new Error('Generation aborted'),
      };
    }

    console.error('PPT generation failed:', error);
    return {
      success: false,
      error,
    };
  }
}
